// const BASE_URL="http://hagrid.prod.use-1d.infra/"
const requestsMap = {

	getImageTags: {
		method: 'POST',
		url: function(params) {
			const { vertical } = params;
			return `https://ai-demo-api.unbxd.io/visual_understanding/verticals/${vertical}/tag`;
		},
	},
	getCompleteLook:{
		method: 'POST',
		url: function() {
			
			return `https://ai-demo-api.unbxd.io/visual_understanding/verticals/apparel/ctl?alt_model=true`;
		},
	},
	getDescriptionBaseDoc:{
		method: 'POST',
		url: function() {
			return `https://ai-demo-api.unbxd.io/document_understanding/verticals/apparel/tag`;
		},
	}
	
};

export default requestsMap;
